export const MailchimpForm = () => {
  return (
    <section>
      <p>Conctact: me@EmanuelCastillo.com</p>
    </section>
  );
};
